// extracted by mini-css-extract-plugin
export var bodyRow = "_dy-d";
export var cardColumns = "_dy-e";
export var ellipsesOverflow = "_dy-2";
export var flatBottomCorners = "_dy-3";
export var flatTopCorners = "_dy-4";
export var headerActionsDropdown = "_dy-f";
export var headerBottomRow = "_dy-c";
export var headerTopRow = "_dy-b";
export var orderDetailsWrapper = "_dy-0";
export var orderInfoContainer = "_dy-1";
export var productDetails = "_dy-9";
export var productImage = "_dy-5";
export var responsiveTable = "_dy-8";
export var shipmentContainer = "_dy-a";
export var tableBottomLeft = "_dy-6";
export var tableBottomRight = "_dy-7";
export var trackingLink = "_dy-g";